import { Provider } from "@redotech/redo-order-common/provider";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const searchProductTags = {
  name: "searchProductTags" as const,
  input: z.object({ searchString: z.string(), provider: createEnum(Provider) }),
  output: z.object({ tags: z.array(z.string()) }),
};
